import { useAppSelector } from '../store/hooks';
import { InfoModalBtn } from './InfoModalBtn';
import {
  convertUrlToEnv,
  getQueryParamValue,
  handleClipboardCopy,
  triggerGtmEvent,
} from '../misc/functions';
import { gtmEvents } from '../misc/gtm.constants';
import { COLUMNS } from '../misc/columns.constants';
import { selectPreparedData } from '../features/table/table.selectors';

export function ResultsControls() {
  const websitesData = useAppSelector((state) => state.table.websitesData);
  const preparedData = useAppSelector(selectPreparedData);
  const env = websitesData?.env;
  const convertLinksTo =
    getQueryParamValue('convertLinksTo') || getQueryParamValue('clt');
  const convertLinks = convertLinksTo && convertLinksTo !== env;

  function onCopyWebsitesUrlsClick() {
    const websitesUrls = preparedData
      .map((website) => {
        const host =
          (convertLinks &&
            convertUrlToEnv(
              website[COLUMNS.website] as string,
              convertLinksTo,
            )) ||
          (website[COLUMNS.host] as string);

        return `https://${host}/`;
      })
      .join('\n');
    void handleClipboardCopy(websitesUrls);

    triggerGtmEvent(gtmEvents.btn, {
      method: 'copy-websites-urls',
    });
  }

  function onCopyWebsitesClick() {
    const formattedWebsitesList = preparedData
      .map((website) => website[COLUMNS.website])
      .join('\n');
    void handleClipboardCopy(formattedWebsitesList);

    triggerGtmEvent(gtmEvents.btn, {
      method: 'copy-websites',
    });
  }

  if (preparedData.length === 0) {
    return null;
  }

  return (
    <div className="flex-column">
      <button
        className="btn"
        onClick={onCopyWebsitesClick}
        data-qa="copyWebsites"
      >
        copy websites
      </button>

      <button
        className="btn"
        onClick={onCopyWebsitesUrlsClick}
        data-qa="copyWebsitesUrls"
      >
        copy websites urls
      </button>

      <InfoModalBtn />
    </div>
  );
}
